export default __webpack_public_path__ + "static/media/img-food-service.d1954b09.svg";